import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { forgotPassword, resetForgotPassword } from '../../actions/index';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    }
  }

  componentDidMount() {
    // Change style of the wrapper so we can put a background image on
    document.getElementById("wrapper").class = "img-cover";
    document.getElementById("wrapper").style = "background-image: url(assets/img/photos-1/1.jpg); background-repeat: no-repeat; background-size: cover";
  }

  componentWillUnmount() {
    // reset the wrapper class to the original value
    document.getElementById("wrapper").class = "wrapper";
    document.getElementById("wrapper").style = '';
  }

  componentWillMount() {
    this.props.resetForgotPassword();
  }

  handleEmail = event => {
    this.setState({email: event.target.value});
  }

  handleSubmit = event => {
    this.props.forgotPassword(this.state.email);
    event.preventDefault();
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Error: </strong> {this.props.errorMessage}
        </div>
      );
    }
  }

  renderButton() {
    if (this.props.loading) {
      return (
        <div className="center-text pt-1 pb-1">
          <img src="/assets/img/spinner.gif" width="30" height="30" alt="Waiting to confirm password reset email sent" />
        </div>
      )
    } else {
      return (
        <div className="px-2 form-group mb-0 pt-1">
          <button action="submit" className="btn btn-rounded btn-secondary btn-block text-uppercase">Send Reset Email</button>
        </div>
      );
    }
  }

  renderForm() {
    if (this.props.showForm) {
      return (
        <form className="form-material mb-1" onSubmit={this.handleSubmit}>
          <fieldset className="form-group">
            <input name="email" value={this.state.email} onChange={this.handleEmail} type="text" className="form-control" placeholder="Email" />
          </fieldset>
          {this.renderAlert()}
          {this.renderButton()}
        </form>
      );
    } else {
      return (
        <div className="center-text pl-1 pr-1">
          <span className="h5 text-success">Please check your email for a message on how to reset your password.</span>
        </div>
      );
    }

  }

  render() {
    return (
      <div className="container-fluid">
        <div className="sign-form">
          <div className="row">
            <div className="col-md-4 offset-md-4 px-3">
              <div className="box b-a-0 mb-0">
                <div className="p-2 text-xs-center">
                  <h5>DineOS Forgot Password</h5>
                </div>
                {this.renderForm()}
                <div className="p-2 text-xs-center text-muted">
                  Want to sign in? <a className="text-black" href="/">Sign In</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { errorMessage: state.auth.error, showForm: state.auth.forgotPassword, loading: state.auth.loading };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ forgotPassword, resetForgotPassword }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/auth/forgot_password.js